exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonGridContainer__MainModal-module___3skbf {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  grid-gap: 8px 8px;\n}\n\n.buttonContainer__MainModal-module___vh6Io {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.modal__MainModal-module___13OC_ {\n  background-color: #0000001d;\n}\n\n@media (max-width: 475px) {\n  .buttonContainer__MainModal-module___vh6Io {\n    flex-direction: column;\n  }\n\n  .buttonGridContainer__MainModal-module___3skbf {\n    grid-template-columns: 100%;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"buttonGridContainer": "buttonGridContainer__MainModal-module___3skbf",
	"buttonContainer": "buttonContainer__MainModal-module___vh6Io",
	"modal": "modal__MainModal-module___13OC_"
};